import { getContractListingSide, getContractListingTitle } from '../contractParties';
import { ContractDetail } from '../types';

interface Props {
  contract: ContractDetail;
}

const LISTING_LABELS: Record<ContractDetail['listingType'], string> = {
  JOB: 'Job Listing:',
  MSAAS: "Buyer's listing:",
  SERVICE: 'Service Listing:',
};

const COUNTERPARTY_LABELS: Record<ContractDetail['listingType'], string> = {
  JOB: 'Application:',
  MSAAS: 'Response:',
  SERVICE: 'Inquiry:',
};

// [MCV-1889] An MSAAS listing is named for whoever posted it: the buyer's listing is a SEEKING one,
// the supplier's an OFFERING one. SERVICE and JOB keep their own names.
const listingLabel = (contract: ContractDetail) =>
  contract.listingType === 'MSAAS' && getContractListingSide(contract) === 'OFFERING'
    ? "Supplier's listing:"
    : LISTING_LABELS[contract.listingType];

const counterpartyLabel = (contract: ContractDetail) =>
  contract.listingType === 'MSAAS' && getContractListingSide(contract) === 'OFFERING'
    ? 'Request:'
    : COUNTERPARTY_LABELS[contract.listingType];

export const ContractSourceLinks = ({ contract }: Props) => {
  const listingTitle = getContractListingTitle(contract) ?? 'Unknown';

  const counterpartyName = contract.contractedProvider
    ? `${contract.contractedProvider.firstName} ${contract.contractedProvider.lastName}`
    : (contract.contractedEmployer?.employerName ?? null);

  return (
    <div className="mb-6">
      <h4 className="text-sm font-bold text-grey-50 mb-3">Source</h4>
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <span className="text-xs text-grey-500">{listingLabel(contract)}</span>
          <span className="text-xs text-primary-50">{listingTitle}</span>
        </div>
        {counterpartyName && (
          <div className="flex items-center gap-2">
            <span className="text-xs text-grey-500">{counterpartyLabel(contract)}</span>
            <span className="text-xs text-primary-50">{counterpartyName}</span>
          </div>
        )}
        <div className="flex items-center gap-2">
          <span className="text-xs text-grey-500">Negotiation:</span>
          <span className="text-xs text-primary-50">#{contract.acceptedNegotiationId}</span>
        </div>
      </div>
    </div>
  );
};
